import PropTypes from 'prop-types';

import { countriesCode } from 'constants/countries';

const consultationCountriesProps = PropTypes.oneOf([countriesCode.CA, countriesCode.US]);

export default consultationCountriesProps;
